/**
 * Stamp for the next sync of a session: wall clock, but never behind the
 * previous stamp. The server applies a sync only when its stamp is newer than
 * the one stored, so overtaking requests cannot revert state.
 */
export function nextSyncStamp(last: number | undefined, now = Date.now()) {
  return Math.max(now, (last ?? 0) + 1);
}
